/**
 * Generates a URL for the agency grievance portal based on current environment
 * Uses the agencyName value from sessionStorage set by ROMP API call
 * @returns The complete URL for the agency grievance portal
 */
export function getAgencyUrl(stage: string, agencyName: string): string {
  let baseUrl: string;

  switch (stage) {
    case 'beta-eu':
      baseUrl = 'https://gamma-mena.fra.chat.warehousejobs.in';
      break;
    case 'gamma-eu':
      baseUrl = 'https://preprod-mena.fra.chat.warehousejobs.in';
      break;
    case 'prod-eu':
      baseUrl = 'https://mena.fra.chat.warehousejobs.in';
      break;
    default:
      throw new Error(`Unknown environment: ${stage}`);
  }

  if (!agencyName) {
    return `${baseUrl}/?language=English&country=India&type=Agency%20Hiring&ingressPoint=PHO`;
  }

  return `${baseUrl}/?language=English&country=India&type=Agency%20Hiring&ingressPoint=PHO&agency=${encodeURIComponent(agencyName)}`;
}
